import {
  title_default
} from "./chunk-GI6JXUKL.js";
import {
  icon_default
} from "./chunk-KWWZIFUJ.js";
import {
  link_default
} from "./chunk-6WQWOYMP.js";
import {
  label_default
} from "./chunk-AWEODRKT.js";

// src/blocks/calendar-tile/calendar-tile.tsx
import { format } from "date-fns";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var CalendarTile = ({
  className = "",
  id,
  isDisabled = false,
  items,
  labels = {
    flagLowAvailability: "Few seats left",
    flagSoldOut: "Sold out",
    flagUnavailable: "Sold Out"
  },
  titlePrefix,
  title
}) => {
  if (!title || !items) {
    return;
  }
  const layoutName = "CalendarTile";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${className} pt-2 pl-2 pr-2 min-h-40 bg-heritage-white-full border-[0.5px] border-heritage-off-white-80`,
      "data-layout": layoutName,
      id,
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: `flex flex-col justify-center mb-2 ${isDisabled ? "opacity-[0.32]" : ""}`,
            children: /* @__PURE__ */ jsx(
              title_default,
              {
                level: "h2",
                text: `${titlePrefix} ${title}`,
                className: "body-lg text-start"
              }
            )
          }
        ),
        items.map((item, index) => {
          if (!item.parentShow?.page) return;
          const targetPerformanceSeatMap = `/order/${item.id}/seat-map`;
          const isSoldOut = item.availabilityQty === "S";
          const isLowAvailability = item.availabilityQty === "L";
          const isUnavailable = item.availabilityQty === "U";
          const isInPast = new Date(item.startDate) < /* @__PURE__ */ new Date();
          return /* @__PURE__ */ jsx(
            "div",
            {
              className: "max-w-full relative mb-8 flex flex-col",
              "data-pid": item.id,
              children: /* @__PURE__ */ jsxs(
                "div",
                {
                  className: `flex flex-col justify-center items-start ${isDisabled || isInPast ? "opacity-[0.32]" : ""}`,
                  children: [
                    /* @__PURE__ */ jsx(
                      title_default,
                      {
                        className: `title-sm text-heritage-red-full text-start mb-4 ${(isSoldOut || isUnavailable) && !isDisabled ? "opacity-[0.32]" : ""} max-w-full break-words`,
                        level: "h3",
                        text: /* @__PURE__ */ jsx(
                          link_default,
                          {
                            className: `title-md text-heritage-red-full mb-2 md:w-[80%] lg:w-[100%] ${!(isSoldOut || isUnavailable || isInPast) && !isDisabled ? "" : "pointer-events-none"} ${(isSoldOut || isUnavailable) && !isDisabled ? "opacity-[0.32]" : ""}`,
                            href: targetPerformanceSeatMap,
                            tracking: {
                              component: "Calendar Tile|Show Name",
                              label: item.parentShow?.name
                            },
                            children: item.parentShow?.name
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      link_default,
                      {
                        className: `link group w-full ${!(isSoldOut || isUnavailable || isInPast) && !isDisabled ? "hover:text-heritage-red-full" : " hover:text-heritage-black-full pointer-events-none"} body-xs whitespace-nowrap ${isSoldOut && !isDisabled ? "opacity-[0.32]" : ""}`,
                        "data-performance-id": id,
                        disabled: isDisabled,
                        href: targetPerformanceSeatMap,
                        id,
                        tracking: {
                          component: "Calendar Tile|Book Now",
                          label: targetPerformanceSeatMap.toString()
                        },
                        children: /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap shrink-1 items-center mb-4", children: [
                          /* @__PURE__ */ jsx("span", { className: "mr-2", children: item.category }),
                          format(item.startDate || "", "h:mm aaa"),
                          /* @__PURE__ */ jsx(
                            icon_default,
                            {
                              name: "arrow-short-right",
                              className: "h-[0.7em] pl-1 pt-[0.1em] group-hover:translate-x-1 transition-translate",
                              SVGClassName: "w-auto h-full"
                            }
                          ),
                          (isSoldOut || isLowAvailability || isUnavailable) && !isInPast && !isDisabled && /* @__PURE__ */ jsxs(Fragment, { children: [
                            isSoldOut && /* @__PURE__ */ jsx("div", { className: "mt-2", children: /* @__PURE__ */ jsx(
                              label_default,
                              {
                                text: labels.flagSoldOut,
                                className: "label-notification-faded whitespace-nowrap"
                              }
                            ) }),
                            isUnavailable && /* @__PURE__ */ jsx("div", { className: "mt-2", children: /* @__PURE__ */ jsx(
                              label_default,
                              {
                                text: labels.flagUnavailable,
                                className: "label-notification-faded whitespace-nowrap"
                              }
                            ) }),
                            isLowAvailability && /* @__PURE__ */ jsx("div", { className: "mt-2", children: /* @__PURE__ */ jsx(
                              label_default,
                              {
                                text: labels.flagLowAvailability,
                                className: "label-notification-default whitespace-nowrap"
                              }
                            ) })
                          ] })
                        ] })
                      }
                    )
                  ]
                }
              )
            },
            item.id
          );
        })
      ]
    }
  );
};
var calendar_tile_default = CalendarTile;

export {
  calendar_tile_default
};
